module.exports = __webpack_public_path__ + "static/media/HCMM228.8825f0e9.jpg";